import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentItemViewModel } from 'src/app/models/item.model';
import { PublisherAvatarComponent } from '../publisher-avatar/publisher-avatar.component';

@Component({
  selector: 'app-payment-publisher',
  templateUrl: './payment-publisher.component.html',
  styleUrls: ['./payment-publisher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PublisherAvatarComponent]
})
export class PaymentPublisherComponent {
  @Input() item: PaymentItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectPaymentRequests = new EventEmitter();

  showPaymentRequests(event): void {
    event.stopPropagation();
    this.selectPaymentRequests.emit();
  }
}
